import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, Archive, Clock, Settings as Cog, LogOut, CreditCard, Plug, FileText } from "lucide-react";
import { useAuth } from "@/lib/auth";
import ThemeToggle from "@/components/ThemeToggle";
import PageTransition from "@/components/PageTransition";
import UserMenu from "@/components/UserMenu";
import BrandLogo from "@/components/BrandLogo";

const NAV = [
    { to: "/app", icon: Home, label: "Accueil", end: true, testId: "nav-home" },
    { to: "/app/transactions", icon: CreditCard, label: "Transactions", testId: "nav-transactions" },
    { to: "/app/recaps", icon: FileText, label: "Récaps", testId: "nav-recaps" },
    { to: "/app/connections", icon: Plug, label: "Connexions", testId: "nav-connections" },
];

export default function AppShell() {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen">
            {/* Top bar */}
            <header className="fixed top-0 inset-x-0 z-40 tk-glass">
                <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
                    <Link to="/accueil" className="flex items-center gap-2" data-testid="appshell-logo" aria-label="Accueil Ticketify">
                        <BrandLogo height={44} />
                    </Link>
                    <nav className="hidden md:flex items-center gap-1">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                end={n.end}
                                data-testid={n.testId}
                                className={({ isActive }) =>
                                    `px-4 py-2 rounded-full text-sm transition ${isActive ? "bg-[#1D1D1F] text-white" : "text-[#1D1D1F] hover:bg-black/5"}`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </nav>
                    <div className="flex items-center gap-3">
                        <ThemeToggle />
                        <UserMenu />
                    </div>
                </div>
                {/* Mobile nav */}
                <div className="md:hidden border-t border-black/5 px-3 py-2 flex gap-1 overflow-x-auto">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.end}
                            data-testid={`mobile-${n.testId}`}
                            className={({ isActive }) =>
                                `flex-1 text-center px-3 py-2 rounded-full text-xs ${isActive ? "bg-[#1D1D1F] text-white" : "text-[#1D1D1F]"}`
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </div>
            </header>

            <main className="pt-28 md:pt-24 pb-16">
                <PageTransition mode="full">
                    <Outlet />
                </PageTransition>
            </main>
        </div>
    );
}
